import { StaticAssetsContext } from '@contexts/static-assets'
import ContentfulAsset from '@entries/contentful-asset'
import React, { useContext } from 'react'

export const StaticAsset = ({ name }: { name: string }) => {
  const staticAssets = useContext(StaticAssetsContext)
  const asset = staticAssets[name] || null
  return asset ? <ContentfulAsset content={asset} /> : null
}
